import { computed, ref, watch } from 'vue';
import InboxesAPI from 'dashboard/api/inboxes';

const AGENT_USAGE_WEIGHT = 2;

const templateKey = template =>
  `${template.name?.toLowerCase() || ''}:${template.language?.toLowerCase() || ''}`;

const rankingScore = usage =>
  (usage.agent || 0) * AGENT_USAGE_WEIGHT + (usage.total || 0);

export const useWhatsAppTemplateRanking = ({ inboxId, templates }) => {
  const templateUsage = ref(new Map());

  const loadTemplateUsage = async () => {
    if (!inboxId.value) {
      templateUsage.value = new Map();
      return;
    }

    try {
      const { data } = await InboxesAPI.getWhatsAppTemplateUsage(inboxId.value);
      templateUsage.value = new Map(
        data.usage.map(record => [templateKey(record), record])
      );
    } catch {
      templateUsage.value = new Map();
    }
  };

  const rankedTemplates = computed(() =>
    [...templates.value].sort((first, second) => {
      const firstUsage = templateUsage.value.get(templateKey(first)) || {};
      const secondUsage = templateUsage.value.get(templateKey(second)) || {};

      return (
        rankingScore(secondUsage) - rankingScore(firstUsage) ||
        (secondUsage.agent || 0) - (firstUsage.agent || 0) ||
        first.name.localeCompare(second.name)
      );
    })
  );

  watch(inboxId, loadTemplateUsage, { immediate: true });

  return { rankedTemplates, loadTemplateUsage };
};
